import { RouterModule } from "@angular/router";
import { BreadcrumbComponent } from "@core/components/ui/breadcrumb/breadcrumb.component";
import { HeaderComponent } from "@core/components/ui/header/header.component";
import { SidebarComponent } from "@core/components/ui/sidebar/sidebar.component";
import { ChangeDetectionStrategy, Component, computed, inject, Signal } from "@angular/core";
import { ExtjsService } from "@core/services/extjs/extjs.service";
import { ExtjsComponent } from "../../pages/extjs/extjs.component";
import { NotificationMenuComponent } from "@core/components/notification/notification-menu/notification-menu.component";

@Component({
  selector: "app-core-layout-secure",
  templateUrl: "./secure.component.html",
  styleUrl: "secure.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ SidebarComponent, HeaderComponent, BreadcrumbComponent, RouterModule, ExtjsComponent, NotificationMenuComponent ]
})
export class SecureComponent {
  private readonly extjsService: ExtjsService = inject(ExtjsService);

  ready: Signal<boolean> = this.extjsService.isWildCardRouted;

  wasWildCardRouted: Signal<boolean> = this.extjsService.wasWildCardRouted;

  createReadySignal (): Signal<boolean> {
    return computed(() => this.extjsService.isWildCardRouted());
  }
}
